// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasObjectsAlignTop: CreateIconOptions = {
  "displayName": "FASObjectsAlignTop",
  "viewBox": "0, 0, 512, 512",
  "d": "M24 0L488 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24S10.7 0 24 0zM64 176c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-288zm224 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-160z"
};
